const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());

  // itg js
   if (totalPages <= 1) {
     document.querySelectorAll('#product-grid .collection-product-card.normal_products ,#product-grid .collection-product-card.sold-out, #product-grid .collection-product-card.closeout, #product-grid .collection-product-card.final-sale')
      .forEach(product => {
        product.style.display = 'block';
      });
      if (button) button.remove();
      return;
   }
  // itg js end

  let currentPage = parseInt($('[data-current-page]').val());

  let currentPageScroll = currentPage + 1;

  currentPage = currentPage+1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();
    },
    
    complete: function() {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
          checkVisibility();
              if (typeof SwymWishlistPlus !== 'undefined' && typeof SwymWishlistPlus.reinitialize === 'function') {
                   SwymWishlistPlus.reinitialize();
              }

        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        // itg js
          if (currentPage == totalPages) {
            button.remove();
            document.querySelectorAll('#product-grid .collection-product-card.normal_products').forEach(function(product_list){
              product_list.style.display = 'block';
            });
              document.querySelectorAll('#product-grid .collection-product-card.closeout').forEach(function(product_list){
              product_list.style.display = 'block';
            });
            document.querySelectorAll('#product-grid .collection-product-card.final-sale').forEach(function(product_list){
              product_list.style.display = 'block';
            });
            document.querySelectorAll('#product-grid .collection-product-card.sold-out').forEach(function(product_list){
              product_list.style.display = 'block';
            });
          }
         // itg js end
      } 
    }
  })
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();